import { API, AxiosWrapperV2 } from "../.."
import { Files, Network } from "../../.."
import store from "../../../../store"
import { axiosWrapper } from "../../../axios_old"
import { PLAN_TYPE } from "../../../constants"
import { formatDate, getCurrency } from "../../../formating"
import { normalizeString } from "../../../functions"
import APIWrapper from "../../APIWrapper"
import Person from "../profile/Person"

// Replace TS enum with plain JS object
export const PLAN_DOC_TYPE = {
  SUMMARY: "SUMMARY",
  PLAN: "PLAN",
  APPENDIX: "APPENDIX",
  EMPLOYEE_NOTICE: "EMPLOYEE_NOTICE",
  ADMIN_SERVICES_AGREEMENT: "ADMIN_SERVICES_AGREEMENT",
  ACH: "ACH",
  PLAN_DESCRIPTION: "PLAN_DESCRIPTION",
  PLAN_OVERVIEW: "PLAN_OVERVIEW",
  EXHIBIT_B: "EXHIBIT_B",
  MUTUAL_MARKETING_AGREEMENT: "MUTUAL_MARKETING_AGREEMENT",
  EMPLOYER_INVOICE: "EMPLOYER_INVOICE"
}

export class PlanDocTemplateAttributes extends APIWrapper {
  constructor(attributes) {
    super(attributes)
    Object.assign(this, attributes)
  }

  get tableValues() {
    return {
      created: formatDate({ data: this.createdTs, actions: ["display"] })
    }
  }
}

export class PlanDocTemplate extends PlanDocTemplateAttributes {
  static async getAll() {
    const {
      data: { data: templatesData }
    } = await AxiosWrapperV2.get({
      url: "plan/template"
    })

    const templates = new Map()
    templatesData.forEach((template) => {
      if (templates.has(template.planType)) {
        templates.set(template.planType, {
          [template.type]: new this(template),
          ...templates.get(template.planType)
        })
      } else {
        templates.set(template.planType, {
          [template.type]: new this(template)
        })
      }
    })

    return templates
  }

  static async uploadOne({ params, data }) {
    const {
      data: { data: templatesData }
    } = await AxiosWrapperV2.upload(
      `plan/template/${params.planType}/${params.templateType}`,
      data.file
    )

    store.setNotification("notification", true, {
      msg: `Successfully uploaded ${params.templateType} for ${params.planType}`
    })

    return new this(templatesData)
  }

  get tableValues() {
    return {
      plan: this.planType,
      name: this.name,
      created: formatDate({ data: this.createdTs, actions: ["display"] })
    }
  }

  async update({ data }) {
    try {
      return await Network.AxiosWrapperV2.patch({
        url: this.links.update.url,
        data
      })
    } catch (err) {
      console.error(err)
    }
  }

  download() {
    return Files.handleDownloadOrView({
      action: "download",
      url: this.links.serve.url,
      name: this.name,
      type: this.file.mimeType
    })
  }
}

export default PlanDocTemplate
